import type {
  NotificationSummary,
  NotificationView,
} from '@contracts/notifications.types'

import { api } from '../../shared/api'

/** Admin notification center API (ADR-047). */
export const notificationsApi = {
  summary: () => api<NotificationSummary>('/notifications/summary'),
  list: (locale: string) =>
    api<NotificationView[]>('/notifications', {
      query: { limit: 30, locale },
    }),
  seen: () =>
    api<{ updated: number }>('/notifications/seen', { method: 'POST' }),
  read: (id: string) =>
    api<void>(`/notifications/${id}/read`, { method: 'POST' }),
  readAll: () =>
    api<{ updated: number }>('/notifications/read-all', { method: 'POST' }),
  dismiss: (id: string) =>
    api<void>(`/notifications/${id}`, { method: 'DELETE' }),
}
